import React from 'react';

import styled from 'styled-components';

import { desktop, useProductBrowser } from '@techstyle/react-components';

export const GridOverlay = styled.div`
  ${desktop`display:none;`}
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${props => props.theme.colors.scrim};
  z-index: 1;

  z-index: ${({ theme }) => theme.zIndex.productOverlay};
`;

export const ProductGridOverlay = () => {
  const { overlayVisible } = useProductBrowser();

  return overlayVisible ? <GridOverlay /> : null;
};
